module.exports = __webpack_public_path__ + "img/product-2.4663393d.png";